var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{attrs:{"id":"page-playback"}},[_c('player',{attrs:{"playUrl":_vm.playUrl},on:{"waiting":_vm.clearReportVideoView,"playing":_vm.playerPlaying,"pause":_vm.clearReportVideoView,"ended":_vm.playerEnd}},[_c('topBar',{attrs:{"viewReport":_vm.viewReport}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }